module.exports = __webpack_public_path__ + "img/membervip.801cc619.jpeg";